/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionRateServiceVo } from './CommissionRateServiceVo';
import {
    CommissionRateServiceVoFromJSON,
    CommissionRateServiceVoFromJSONTyped,
    CommissionRateServiceVoToJSON,
    CommissionRateServiceVoToJSONTyped,
} from './CommissionRateServiceVo';

/**
 * 
 * @export
 * @interface CommissionRateViewRespVo
 */
export interface CommissionRateViewRespVo {
    /**
     * 推荐码id
     * @type {number}
     * @memberof CommissionRateViewRespVo
     */
    recommendCodeId?: number;
    /**
     * 推荐码
     * @type {string}
     * @memberof CommissionRateViewRespVo
     */
    code?: string;
    /**
     * 适用日期
     * @type {string}
     * @memberof CommissionRateViewRespVo
     */
    applyDate?: string;
    /**
     * 已设置分成比例的附加服务列表
     * @type {Array<CommissionRateServiceVo>}
     * @memberof CommissionRateViewRespVo
     */
    items?: Array<CommissionRateServiceVo>;
}

/**
 * Check if a given object implements the CommissionRateViewRespVo interface.
 */
export function instanceOfCommissionRateViewRespVo(value: object): value is CommissionRateViewRespVo {
    return true;
}

export function CommissionRateViewRespVoFromJSON(json: any): CommissionRateViewRespVo {
    return CommissionRateViewRespVoFromJSONTyped(json, false);
}

export function CommissionRateViewRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionRateViewRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'recommendCodeId': json['recommendCodeId'] == null ? undefined : json['recommendCodeId'],
        'code': json['code'] == null ? undefined : json['code'],
        'applyDate': json['applyDate'] == null ? undefined : json['applyDate'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CommissionRateServiceVoFromJSON)),
    };
}

export function CommissionRateViewRespVoToJSON(json: any): CommissionRateViewRespVo {
    return CommissionRateViewRespVoToJSONTyped(json, false);
}

export function CommissionRateViewRespVoToJSONTyped(value?: CommissionRateViewRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recommendCodeId': value['recommendCodeId'],
        'code': value['code'],
        'applyDate': value['applyDate'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CommissionRateServiceVoToJSON)),
    };
}

